import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import ModalChangeEmailAddressConfirmation from "screens/ModalConfirmationRequired";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { UPDATE_EMAIL_BY_USER_ID } from "graphql/service";
import { Head, Container, Footer } from "./styles";

const ModalChangeEmailAddress = ({
  hidden,
  buttonStyle,
  userId
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [confirmationIsOpen, setConfirmationIsOpen] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  const [updateEmailByUserId, { loading }] = useMutation(UPDATE_EMAIL_BY_USER_ID, {
    onCompleted: () => {
      setIsOpen(false);
      setFailedIsOpen(false);
      setConfirmationIsOpen(true);
      setEmail("");
    },
    onError: () => {
      setIsOpen(false);
      setFailedIsOpen(true);
    }
  });

  const handleChangeEmail = () => {
    if (loading) return;
    let error = false;

    if (email.trim() === "") {
      setEmailError(true);
      error = true;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      setEmailError(true);
      error = true;
    }

    if (error) return;

    updateEmailByUserId({
      variables: {
        input: {
          userId,
          input: {
            email
          }
        },
      },
    })
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Change Email"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Enter New Email Address</Head>
        <Container>
          <Input
            title="EMAIL ADDRESS"
            required
            error={emailError}
            errorMessage="Please enter a valid email address"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError(false);
            }}
            additionalstyle={`
            width: 100%;
          `}
          />
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onClick={handleChangeEmail}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>
      <ModalChangeEmailAddressConfirmation
        isOpen={confirmationIsOpen}
        setIsOpen={setConfirmationIsOpen}
        email={email}
        retryFunction={handleChangeEmail}
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        loading={loading}
        retryFunction={handleChangeEmail}
        type="changeEmail"
      />
    </>
  );
};

export default ModalChangeEmailAddress;
